/**
 * Mind you, this gets translated in media.js.breakpoints
 * to max-width, mobile first, media queries.
 */
export const sizes: any = {
    xl: 1920,
    lg: 1280,
    md: 1024,
    tb: 896,
    sm: 720,
    xs: 320,
};

export const landscapeRule = `(min-aspect-ratio: 5/4)`;
